import { hasInteriorView } from '../data/carModels';
import { buildClassName } from './buildClassName';
import { formatProductionYears } from '../model/modelLabels';
import { preloadCarAsset } from '../three/gltf/carAssetLoader';
import type { CarModel } from '../types';

export interface ModelSelectorProps {
  models: CarModel[];
  selectedModelId: string;
  onModelSelect: (modelId: string) => void;
  /** 이동 모드에서 차량 사양을 잠글 때 true. */
  disabled?: boolean;
}

export function ModelSelector({ models, selectedModelId, onModelSelect, disabled = false }: ModelSelectorProps) {
  return (
    <ul className="model-card-list" aria-label="차량 모델 선택">
      {models.map((model) => {
        const isSelected = model.id === selectedModelId;
        /*
         * 카드에 관심을 보이는 순간 GLB를 미리 받습니다. 누르고 나서 받기 시작하면
         * 그 시간이 통째로 대기로 드러나는데, 여기서 시작해 두면 그만큼이 줄어듭니다.
         *
         * 낭비되지 않는 이유: 이미 받았거나 받는 중이면 drei 캐시가 무시합니다.
         * 터치 기기에서는 hover가 없고 탭할 때 pointerenter가 함께 오므로, 누를 차를
         * 어차피 받게 됩니다. 즉 데이터를 헛되이 쓰는 경로가 아닙니다.
         *
         * focus도 함께 거는 이유는 키보드로 카드를 훑는 경우입니다.
         */
        const prefetch = () => preloadCarAsset(model.asset);
        return (
          <li key={model.id}>
            <button
              type="button"
              className={buildClassName('model-card', 'model-card--selected', isSelected)}
              aria-pressed={isSelected}
              disabled={disabled}
              onClick={() => onModelSelect(model.id)}
              onPointerEnter={prefetch}
              onFocus={prefetch}
            >
              <span className="model-card__body">
                <span className="model-card__brand">{model.brand}</span>
                <span className="model-card__name">{model.shortName}</span>
                <span className="model-card__meta">{formatProductionYears(model.productionYears)}</span>
              </span>
              {/*
                실내가 없는 외관 전용 에셋임을 미리 알려 줍니다.
                누른 뒤에 "내부" 버튼이 잠기는 이유를 알 수 없으면 고장으로 보입니다.
              */}
              {hasInteriorView(model) ? null : <span className="model-card__badge">외관 전용</span>}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
